// A menu of admin actions: a button that opens a list (aldoo-ra Popover,
// anchored, kept in the viewport, closed by a click outside or Escape).
// `items`: [{ label, onClick, disabled, danger, testId }]; `label`: the
// button's text — none gives a compact "⋯" button for a row.
import React, { useRef, useState } from "react"
import Popover from "aldoo-ra/Popover"
import { ChevronDownIcon, EllipsisHorizontalIcon } from "@heroicons/react/24/outline"

export default function ActionsMenu({ label, items = [], align = "end", testId }) {
  const anchor = useRef(null)
  const [open, setOpen] = useState(false)
  const shown = items.filter(Boolean)
  if (!shown.length) return null
  return (
    <>
      <button
        ref={anchor}
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        className={
          label
            ? "inline-flex items-center gap-1.5 h-9 px-4 rounded-full border border-admin_primary text-admin_primary text-sm font-semibold bg-admin_paper hover:bg-admin_primary/5"
            : "inline-flex items-center justify-center h-8 w-8 rounded-full border border-admin_bordered text-admin_text_secondary bg-admin_paper hover:border-admin_primary hover:text-admin_primary"
        }
        data-testid={testId}
      >
        {label ? (
          <>
            {label}
            <ChevronDownIcon className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
          </>
        ) : (
          <EllipsisHorizontalIcon className="w-5 h-5" />
        )}
      </button>
      <Popover open={open} onClose={() => setOpen(false)} anchorRef={anchor} align={align} className="min-w-[220px] py-1 rounded-lg border border-admin_bordered bg-admin_paper shadow-lg">
        <ul role="menu" className="m-0 p-0 list-none">
          {shown.map((item) => (
            <li key={item.label}>
              <button
                type="button"
                role="menuitem"
                disabled={item.disabled}
                onClick={() => {
                  setOpen(false)
                  item.onClick?.()
                }}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-admin_neutral_1/60 disabled:opacity-50 disabled:cursor-not-allowed ${item.danger ? "text-admin_error" : "text-admin_text"}`}
                data-testid={item.testId}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </Popover>
    </>
  )
}
